import { type EChartsExtensionInstallRegisters } from 'echarts/types/src/extension';
import { dvMarkerExtensionInstall } from './adjustRectVerticalPosition';

export function install(registers: EChartsExtensionInstallRegisters) {
  dvMarkerExtensionInstall(registers);
}
